import { render, staticRenderFns } from "./SidebarTermAndCondition.vue?vue&type=template&id=25f355ad&scoped=true&"
import script from "./SidebarTermAndCondition.vue?vue&type=script&lang=js&"
export * from "./SidebarTermAndCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f355ad",
  null
  
)

export default component.exports